// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let UnknownStringValue = /* @__PURE__ */Primitive_exceptions.create("SupplierStatus.UnknownStringValue");

function toLabel(x) {
  if (x === "UNARCHIVED") {
    return I18n.t("Not archived");
  } else {
    return I18n.t("Archived");
  }
}

function toString(status) {
  return status;
}

function fromString(value) {
  switch (value) {
    case "ARCHIVED" :
      return "ARCHIVED";
    case "UNARCHIVED" :
      return "UNARCHIVED";
    default:
      throw {
        RE_EXN_ID: UnknownStringValue,
        Error: new Error()
      };
  }
}

let values = [
  "ARCHIVED",
  "UNARCHIVED"
];

export {
  UnknownStringValue,
  toLabel,
  toString,
  fromString,
  values,
}
/* I18n Not a pure module */
